/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type SwapOfferCreateMutationVariables = Types.Exact<{
	input: Types.SwapOfferCreateRequest;
}>;

export type SwapOfferCreateMutation = {
	__typename?: "Mutation";
	swapOfferCreate: {
		__typename?: "SwapOfferCreateResponse";
		swapOffer: {
			__typename?: "SwapOfferCreate";
			swapOfferId: string;
			userJourney: string;
			isTaxable: boolean;
			isFeeTransparent: boolean;
			sourceTrade: {
				__typename?: "SwapOfferCreateTrade";
				offerId: string;
				assetId: string;
				fiatId: string;
				amountAsset: { __typename?: "CurrencyAmount"; value: string };
				amountFiat: { __typename?: "CurrencyAmount"; value: string };
				feePercentage: { __typename?: "FeePercentage"; value: string };
			};
			vsnFeeTokenCollection?: {
				__typename?: "VsnFeeTokenCollection";
				globalOptIn?: boolean | null;
				enabled: boolean;
				eligibleForVsn: boolean;
				feeDiscount: string;
				visionFeeDetail?: {
					__typename?: "VisionFeeDetail";
					visionRate: string;
					visionAmount: string;
					feeBefore: string;
					hasEnoughFunds: boolean;
					bonus: { __typename?: "Bonus"; amount: string; unitId: string; type: Types.BonusType };
				} | null;
			} | null;
			serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			targetTrade: {
				__typename?: "SwapOfferCreateTrade";
				offerId: string;
				assetId: string;
				fiatId: string;
				amountAsset: { __typename?: "CurrencyAmount"; value: string };
				amountFiat: { __typename?: "CurrencyAmount"; value: string };
				feePercentage: { __typename?: "FeePercentage"; value: string };
			};
			expiresAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			taxWithheld?: {
				__typename?: "Tax";
				isTaxServiceAvailable: boolean;
				fiatId: string;
				assetId?: string | null;
				taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
				fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
				taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
			} | null;
			warnings: Array<{ __typename?: "OfferWarning"; link: string; link_message: string; message: string }>;
			fee?: {
				__typename?: "SwapOfferFee";
				fiatId: string;
				amount: { __typename?: "FeeAmount"; value: string };
				source: { __typename?: "FeeAmount"; value: string };
				target: { __typename?: "FeeAmount"; value: string };
			} | null;
		};
	};
};

export const SwapOfferCreateDocument = gql`
	mutation swapOfferCreate($input: SwapOfferCreateRequest!) {
		swapOfferCreate(request: $input) {
			swapOffer {
				swapOfferId
				sourceTrade {
					offerId
					assetId
					amountAsset {
						value
					}
					amountFiat {
						value
					}
					fiatId
					feePercentage {
						value
					}
				}
				vsnFeeTokenCollection {
					globalOptIn
					enabled
					eligibleForVsn
					feeDiscount
					visionFeeDetail {
						visionRate
						visionAmount
						feeBefore
						hasEnoughFunds
						bonus {
							amount
							unitId
							type
						}
					}
				}
				serverTime {
					iso8601
					unixTimestamp
				}
				targetTrade {
					offerId
					assetId
					amountAsset {
						value
					}
					amountFiat {
						value
					}
					fiatId
					feePercentage {
						value
					}
				}
				expiresAt {
					iso8601
					unixTimestamp
				}
				userJourney
				taxWithheld {
					taxAmountFiat {
						value
					}
					isTaxServiceAvailable
					fiatId
					assetId
					fiatAmountAfterTax {
						value
					}
					taxAmountAsset {
						value
					}
				}
				isTaxable
				warnings {
					link
					link_message
					message
				}
				fee {
					amount {
						value
					}
					source {
						value
					}
					target {
						value
					}
					fiatId
				}
				isFeeTransparent
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class SwapOfferCreateGQLService extends Apollo.Mutation<
	SwapOfferCreateMutation,
	SwapOfferCreateMutationVariables
> {
	document = SwapOfferCreateDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
